<script setup lang="ts">
const locales = useLocales()
</script>

<template>
  <nav class="relative z-10 w-full bg-white shadow-md">
    <div
      class="mx-auto flex items-center justify-between px-4 py-2 sm:px-6 xl:px-8 xl:py-2.5"
    >
      <NuxtLink
        class="relative mr-8 flex shrink-0 items-center xl:mr-0 xl:w-56"
        :to="{ name: 'dashboard' }"
      >
        <LogoSvg class="h-8" />
      </NuxtLink>
      <div class="hidden grow items-center md:flex xl:justify-center">
        <slot />
      </div>
      <div class="flex w-56 items-center gap-4">
        <LocaleSwitcher :locales />
        <FormButton to="/dashboard" variant="secondary">
          {{ $t("human_risk_intelligence.onboarding.common.cancel") }}
          <SvgoPikaClose class="ml-2 size-5" />
        </FormButton>
      </div>
    </div>
  </nav>
</template>
